import { createFileRoute } from '@tanstack/react-router';

import { TemplateLoading } from '@/_pages/contacts/template/template-loading';

export const Route = createFileRoute('/_private/contacts/_template')({
  pendingComponent: TemplateLoading,
});
